import * as HttpService from "../../../../service/HttpService";

/**
 * 新增工单
 */
export const addDefectWorkOrder = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/rushRepairSheet/addWorkOrder",data);
};

/**
 * 获取工单列表
 */
export const getWorkOrder = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/rushRepairSheet/getWorkOrder",data);
};

/**
 * 删除工单
 */
export const deleteElectricity = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/rushRepairSheet/deleteElectricity",data);
};

/**
 * 新增处理信息
 */
export const handleElectricity = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/rushRepairSheet/handleElectricity",data);
};

/**
 * 新增验收信息
 */
export const examineElectricity = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/rushRepairSheet/examineElectricity",data);
};


/**
 * 更新工单
 */
export const editEfectWorkOrder = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/rushRepairSheet/editEfectWorkOrder",data);
};









